module.exports = __webpack_public_path__ + "static/media/right-white.31aa508e.svg";